import { EMAIL_LEAD_EVENTS } from "@website-builder/utilities/constants/click-events.js";

export const validateEmail = (value) => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (emailRegex.test(value)) {
		return true;
	}
	if (value && value.length) {
		return "Please enter a valid email address";
	} else {
		return "This field is required";
	}
};

/**
 * Is this CTA event one that submits a lead keyed on the user's email address?
 * quiz_start is an API event but is NOT an email lead event - see EMAIL_LEAD_EVENTS.
 */
export const isEmailLeadEvent = (event) => EMAIL_LEAD_EVENTS.includes(event);

/**
 * Resolve the email a CTA is about to submit. apiData.params.email is authoritative -
 * it is what postRequest appends to the request body. eventData.email is only the
 * analytics mirror, so it is used solely when params.email was never provided; an
 * explicitly empty params.email must not fall through to it.
 */
export const resolveLeadEmail = (apiData, eventData) => {
	const paramsEmail = apiData?.params?.email;
	if (paramsEmail !== undefined && paramsEmail !== null) {
		return paramsEmail;
	}
	return eventData?.email;
};

/**
 * The single gate for email lead CTAs.
 * @returns {string|null} null when the click may proceed, otherwise the user-facing
 *          error string produced by validateEmail.
 */
export const getLeadEmailError = (event, email) => {
	if (!isEmailLeadEvent(event)) {
		return null;
	}
	const result = validateEmail(email);
	return result === true ? null : result;
};
